import { useFormContext } from "react-hook-form";
import useEvent from "react-use-event-hook";

import { BOOKING_UPLOAD_FORM_FIELDS, Log } from "@ryde/shared";

export const useBulkBookingUploadForm = () => {
  const { setValue } = useFormContext();

  const onFileChange = useEvent((file: File) => {
    Log.debug("onFileChange event, file:", file);
    setValue(BOOKING_UPLOAD_FORM_FIELDS.file, file);
  });

  const onFileClear = useEvent(() => {
    Log.debug("onFileClear event");
    setValue(BOOKING_UPLOAD_FORM_FIELDS.file, undefined);
  });

  return {
    onFileChange,
    onFileClear,
  };
};
